import type { FaireProductEntity } from "../../entity_types/product";

export const p_4p6ty5fm8t: FaireProductEntity = {
  token: "p_4p6ty5fm8t",
  type: "product",
  name: "Sweet Basil CARINARA",
  brandToken: "b_pb4tgncq54",
  brandName: "CARINARA",
  imageUrl:
    "https://cdn.faire.com/fastly/f0415414676e951a934058ae32784801a34e4aa81d243067d4d3afd61aa371d5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ef990df5774f4e84cf0fd665cd614daa77e9c6e11585384bbe06d5d192c7d7af.jpeg",
    "https://cdn.faire.com/fastly/b7d58368e214380c65527e441a1e8d816567a55dc5ca0ccf66a927692f3cfbb7.jpeg",
    "https://cdn.faire.com/fastly/7b87d07de8dfcdbc964be0eb15bf3c17a3720275c002c7322b0fbc570d75e7f8.jpeg",
    "https://cdn.faire.com/fastly/1114d74e79c8e4f04fd15f8a46325f6809dd903f23261277e8d6afa72663dbd7.png",
  ],
  priceDollars: 8.4,
  description:
    "Inspired by the natural sweetness of earth's basil, we highlighted this ingredient while pairing it with raw honey for those who crave a sweeter sauce. No artificial sugars or sweeteners.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:11.351Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
